<template>
  <v-layout class="booking-duration">
    <v-icon size="16">icon-Time</v-icon>
    <span class="duration-string">{{durationString}}</span>
  </v-layout>
</template>

<script>

  export default {
    name: "BookingDuration",
    props: {
      start_time: {
        type: String,
        required: true,
      },
      duration: {
        type: Number,
        required: true,
      },
      timeZone: {
        type: String,
        required: true,
      },
      format: {
        type: String,
        required: true,
      }
    },
    computed: {
      durationString() {
        const start_time = new Date(this.start_time);
        const end_time = new Date(start_time.getTime() + this.duration * 60000);
        return `${this.$options.filters.dateFormatUTC(start_time, this.format, this.timeZone)} - ${this.$options.filters.dateFormatUTC(end_time, this.format, this.timeZone)}`;
      },
    },
  };
</script>

<style lang="scss" scoped>

  .booking-duration {
    white-space: nowrap;

    .duration-string {
      padding: 0 6px;
    }
  }

</style>
